import { cn } from "@/lib/cn";
import * as React from "react";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea"> & { error?: boolean }
>(({ className, error, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "scrollbar tw-flex tw-h-40 tw-w-full tw-resize-none tw-items-center tw-justify-start tw-rounded-lg tw-outline tw-outline-1 tw-outline-blue/5 tw-bg-white tw-p-3 tw-font-sans tw-text-sm tw-font-normal placeholder:tw-text-blue-500 focus:tw-outline-violet-700",
        error &&
          "tw-outline-[#D43548] focus:tw-outline-[#D43548] tw-bg-[#FAF1F2] tw-text-[#D43548] placeholder:tw-text-[#D43548]/80",
        className,
        props.disabled &&
          "tw-bg-blue-100 tw-outline-blue-200 tw-text-blue-300 placeholder:tw-text-blue-300",
      )}
      ref={ref}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export default Textarea;
